import { useState } from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { resendVerification } from '../../api/authApi';

export default function RegisterPendingPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') ?? '';
  const [resendState, setResendState] = useState('idle'); // 'idle' | 'loading' | 'sent' | 'error'

  const handleResend = async () => {
    setResendState('loading');
    try {
      await resendVerification(email);
      setResendState('sent');
    } catch {
      setResendState('error');
    }
  };

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Подтвердите ваш e-mail
            </p>
          </div>

          <Card
            className="border-0"
            style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}
          >
            <Card.Body className="p-4 text-center">
              <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✉️</div>

              <h5 className="fw-bold mb-3">Проверьте почту</h5>

              <p className="mb-2" style={{ fontSize: '0.9rem' }}>
                На адрес <strong>{email}</strong> отправлено письмо с подтверждением.
                Перейдите по ссылке в письме, чтобы завершить регистрацию.
              </p>

              <p className="text-muted mb-4" style={{ fontSize: '0.8rem' }}>
                Если письмо не пришло, проверьте папку «Спам».
              </p>

              <Button
                variant="outline-secondary"
                size="sm"
                onClick={handleResend}
                disabled={resendState === 'loading' || resendState === 'sent'}
                style={{ borderRadius: '0.5rem' }}
              >
                {resendState === 'loading' && 'Отправляем...'}
                {resendState === 'sent' && '✓ Письмо отправлено'}
                {resendState === 'error' && 'Ошибка — попробуйте позже'}
                {resendState === 'idle' && 'Отправить повторно'}
              </Button>
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
            Уже подтвердили?{' '}
            <Link
              to="/login"
              style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
            >
              Войти
            </Link>
          </p>
        </div>
      </Container>
    </div>
  );
}
